import { doDefaultFetch } from '@nhl/fetch-helpers';

const fetchTieBreakingProcedureForSeason = args => {
    return doDefaultFetch(
        `/site/api/tieBreakingProcedure/${args.season}`,
        args
    );
};

export default {
    fetchTieBreakingProcedureForSeason,
};
